import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';
import { CREATE_OR_UPDATE_UMSATZ_PLANWERT_AND_INTERNE_NOTIZ } from './graphql/mutations';
import {
  CreateOrUpdateUmsatzPlanWertAndInterneNotizMutation,
  CreateOrUpdateUmsatzPlanWertAndInterneNotizMutationVariables,
} from '@/gql/graphql';

export function useUmsatzPlanWertCreateOrUpdate() {
  const [execute, result] = useMutation<
    CreateOrUpdateUmsatzPlanWertAndInterneNotizMutation,
    CreateOrUpdateUmsatzPlanWertAndInterneNotizMutationVariables
  >(CREATE_OR_UPDATE_UMSATZ_PLANWERT_AND_INTERNE_NOTIZ, {
    refetchQueries: [
      'getPlanwerteByStandortId',
      'getHistorie',
      'getTagebuchEintraegeByStandortIds',
    ],
  });

  const createOrUpdateUmsatzPlanWert = useCallback(
    (
      variables: CreateOrUpdateUmsatzPlanWertAndInterneNotizMutationVariables,
    ) => {
      return execute({ variables });
    },
    [execute],
  );

  return [createOrUpdateUmsatzPlanWert, result] as const;
}
